import { useContext } from 'react'

import { FrameBuilderSelectionContext } from '../../contexts/selection-context'
import { FrameBuilderStringsContext } from '../../contexts/strings-context'
import { FrameBuilderValidationContext } from '../../contexts/validation-context'

import ConfigurationStepPreview, {
  type StepPreviewProps,
} from './configuration-step-preview'

const ArtworkSizeStepPreview = ({ number, onClick }: StepPreviewProps) => {
  const frameBuilderStrings = useContext(FrameBuilderStringsContext)
  const { committedStateSelectionMessages } = useContext(
    FrameBuilderSelectionContext,
  )
  const { stepPreviewAnimation, validationMessages } = useContext(
    FrameBuilderValidationContext,
  )

  return (
    <ConfigurationStepPreview
      step="artworkSize"
      title={frameBuilderStrings.artworkSizeStepTitle}
      value={committedStateSelectionMessages?.artworkSize}
      error={validationMessages?.artowkSizePreview}
      placeholder={frameBuilderStrings.artworkSizePlaceholder}
      opacity={stepPreviewAnimation.artworkSizeOpacity}
      number={number}
      onClick={onClick}
      className="grow-0 shrink-0"
    />
  )
}

export default ArtworkSizeStepPreview
